export const topPanelHeaderHightDesktop = '40px'
